import {
  DateRangeSelector,
  ENUM_DATE_RANGE,
  getDateRangeSelector
} from '@cokitchen/cokitchen-components';
import ExportButton from 'components/base/export-button';
import PageHeaderText from 'components/base/page-header-text';
import React, { useState } from 'react';
import RecalledOrderTable from './recalled-order-table';
import ExportModal from 'components/cs/modals/export-modal';
import { apiService } from 'utils/api';
import { handleApiError } from 'utils/functions';
import useDashboardContext from 'contexts/dashboard.context';

const RecalledOrders = () => {
  const { activeCokitchen } = useDashboardContext();
  const [showExportModal, setShowExportModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const [filters, setFilters] = useState({
    dateRange: getDateRangeSelector(ENUM_DATE_RANGE.THIS_WEEK)
  });
  const exportIssues = async (email: string, dateRange: { startDate: Date; endDate: Date }) => {
    try {
      setLoading(true);
      const res = await apiService.post('logistics/export-recalled-orders', {
        data: {
          cokitchen_id: activeCokitchen.id,
          email,
          start_date: dateRange.startDate,
          end_date: dateRange.endDate
        },
        baseUrl: process.env.REACT_APP_ORDER_STATS_API_KEY
      });
      if (res.data) {
        setShowExportModal(false);
      }
    } catch (e) {
      handleApiError(e);
    } finally {
      setLoading(false);
    }
  };
  return (
    <div>
      <PageHeaderText title='Recalled Orders' description='Manage recalled orders' />
      <div className='flex justify-between items-center '>
        <DateRangeSelector
          onChange={(v) => setFilters({ ...filters, dateRange: v.date })}
          showTime
        />

        <ExportButton onClick={() => setShowExportModal(true)} />
      </div>
      <div className='mt-8'>
        <RecalledOrderTable dateRange={filters.dateRange} />
      </div>
      <ExportModal
        loading={loading}
        show={showExportModal}
        onClose={() => setShowExportModal(false)}
        title='Export Issues'
        onSubmit={(
          email: string,
          dateRange: {
            startDate: Date;
            endDate: Date;
          }
        ) => exportIssues(email, dateRange)}
      />
    </div>
  );
};

export default RecalledOrders;
